module.exports = __webpack_public_path__ + "img/downtown.81a5e561.png";